 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVERPAGE from '@/components/CoverPage'
 import HALFTITLE from '@/components/HalfTitle'
 import LOVE_1 from '@/components/love_1'
 import TITLEPAGE from '@/components/TitlePage'
 import COPYRIGHTPAGE from '@/components/CopyrightPage'
 import DEDICATION from '@/components/Dedication'
 import AUTHORSNOTE from '@/components/AUTHORSNOTE'
 import ABC from '@/components/abc'
 import FOREWORD from '@/components/Foreword'
 import ACKNOWLEDGMENTS from '@/components/Acknowledgments'
 import LOYALTOTHESKY from '@/components/LoyaltotheSky'
 import ONE from '@/components/One'
 import TWO from '@/components/Two'
 import THREE from '@/components/Three'
 import FOUR from '@/components/Four'
 import FIVE from '@/components/Five'
 import SIX from '@/components/Six'
 import SEVEN from '@/components/Seven'
 import SANFRANCISCO from '@/components/SanFrancisco'
 import DASW from '@/components/DASW'
 import EIGHT from '@/components/Eight'
 import NINE from '@/components/Nine'
 import TEN from '@/components/Ten'
 import ELEVEN from '@/components/Eleven'
 import TWELVE from '@/components/Twelve'
 import LOVE_2 from '@/components/love_2'
 import EPILOGUE from '@/components/Epilogue'
 import DISCUSSIONGUIDE from '@/components/DiscussionGuide'
 import INDEX from '@/components/Index'
 import ABOUTTHEAUTHOR from '@/components/AbouttheAuthor'
 import ABOUTBERRETTKOEHLERPUBLISHERS from '@/components/AboutBerrettKoehlerPublishers'
 import BECONNECTED from '@/components/BeConnected'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/CoverPage",
 			"name" : "CoverPage",
 			"component" : COVERPAGE
 		},
 		{
 			"path" : "/HalfTitle",
 			"name" : "HalfTitle",
 			"component" : HALFTITLE
 		},
 		{
 			"path" : "/love_1",
 			"name" : "love_1",
 			"component" : LOVE_1
 		},
 		{
 			"path" : "/TitlePage",
 			"name" : "TitlePage",
 			"component" : TITLEPAGE
 		},
 		{
 			"path" : "/CopyrightPage",
 			"name" : "CopyrightPage",
 			"component" : COPYRIGHTPAGE
 		},
 		{
 			"path" : "/Dedication",
 			"name" : "Dedication",
 			"component" : DEDICATION
 		},
 		{
 			"path" : "/AUTHORSNOTE",
 			"name" : "AUTHORSNOTE",
 			"component" : AUTHORSNOTE
 		},
 		{
 			"path" : "/abc",
 			"name" : "abc",
 			"component" : ABC
 		},
 		{
 			"path" : "/Foreword",
 			"name" : "Foreword",
 			"component" : FOREWORD
 		},
 		{
 			"path" : "/Acknowledgments",
 			"name" : "Acknowledgments",
 			"component" : ACKNOWLEDGMENTS
 		},
 		{
 			"path" : "/LoyaltotheSky",
 			"name" : "LoyaltotheSky",
 			"component" : LOYALTOTHESKY
 		},
 		{
 			"path" : "/One",
 			"name" : "One",
 			"component" : ONE
 		},
 		{
 			"path" : "/Two",
 			"name" : "Two",
 			"component" : TWO
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js